import { GetCrecaAccountsApi } from "@/features/accounts/creca/services/get-accounts-api";
import { GetCrecaAccountsRequestModel } from "@/features/accounts/creca/services/get-accounts-model";

/// クレカ一覧取得処理
export class GetCrecaAccountsService {
  private getCrecaAccountsApi = new GetCrecaAccountsApi();

  /**
   * クレカ一覧取得API実行
   */
  public async getCrecaAccounts(param: GetCrecaAccountsRequestModel) {
    return await this.getCrecaAccountsApi.getCrecaAccounts(param);
  }
}
